import { render, staticRenderFns } from "./CoreFormInput.vue?vue&type=template&id=63c76d86"
import script from "./CoreFormInput.vue?vue&type=script&lang=js"
export * from "./CoreFormInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports